// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2bMLo","content":"Consent_content__3GBFa","footer":"Consent_footer__1xtfs"};